/**
 * Globale Konstanten für die Frontend-Anwendung
 */

// API-Konfiguration: nur der Ursprung, die Pfade der Endpoints beginnen mit /api/v1. Ohne
// VITE_API_URL das lokale Backend auf dem Port aus apps/backend/.env.example.
export const API_BASE_URL = import.meta.env.VITE_API_URL || "http://localhost:3300";

// Authentifizierung
export const TOKEN_STORAGE_KEY = "TOKEN";
export const REFRESH_TOKEN_STORAGE_KEY = "REFRESH_TOKEN";

// Paginierung
export const DEFAULT_PAGE_SIZE = 10;

// Telefonnummern
// Stripe erlaubt für `customer.phone` maximal 20 Zeichen. Längere Werte lassen
// die Stripe-Kundenanlage (und damit z. B. das Anlegen einer Niederlassung)
// fehlschlagen, deshalb werden alle Telefon-Eingabefelder hier begrenzt.
export const PHONE_MAX_LENGTH = 20;

// Zeichen, die in einer Telefonnummer nicht vorkommen dürfen: erlaubt sind Ziffern,
// "+", Klammern, Schrägstrich, Bindestrich und Leerzeichen.
export const PHONE_DISALLOWED_CHARS = /[^\d+()/ -]/g;

// Für Hinweistexte: die erlaubten Sonderzeichen in lesbarer Form.
export const PHONE_ALLOWED_CHARS_LABEL = "+ ( ) / -";

// Datums- und Zeitformate
export const DATE_FORMAT = "DD.MM.YYYY";
export const TIME_FORMAT = "HH:mm";
export const DATETIME_FORMAT = `${DATE_FORMAT} ${TIME_FORMAT}`;

// Status-Codes
export const STATUS_CODES = {
  ACTIVE: 1,
  INACTIVE: 0,
};

// Rollen
export const ROLES = {
  ADMIN: "admin",
  SUPER_ADMIN: "superAdmin",
  USER: "user",
};

// Routen
export const ROUTES = {
  HOME: "/",
  LOGIN: "/login",
  DASHBOARD: "/dashboard",
  PROFILE: "/profile",
  USERS: "/users",
  COMPANIES: "/companies",
  FACILITIES: "/facilities",
  SETTINGS: "/settings",
};

export const REGEX = {
  password:
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&\-_#+=<>{}[\]|~`^])[A-Za-z\d@$!%*?&\-_#+=<>{}[\]|~`^]{8,}$/,
  email:
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  phone: /^(?:(?:\+|00)49|0)(?:[1-9][0-9]{1,4})?(?:[ -/]?[0-9]{1,7})(?:[ -/]?[0-9]{1,5})?$/,
  iban: /^([A-Z]{2}[ '+'\\\\'+'-]?[0-9]{2})(?=(?:[ '+'\\\\'+'-]?[A-Z0-9]){9,30}\$)((?:[ '+'\\\\'+'-]?[A-Z0-9]{3,5}){2,7})([ '+'\\\\'+'-]?[A-Z0-9]{1,3})?$/,
  bic: /^[A-Z]{4}([A-Z]{2})[A-Z0-9]{2}([A-Z0-9]{3})?$/,
  emoji:
    /[\u{1F600}-\u{1F64F}]|[\u{1F300}-\u{1F5FF}]|[\u{1F680}-\u{1F6FF}]|[\u{1F1E0}-\u{1F1FF}]|[\u{2600}-\u{26FF}]|[\u{2700}-\u{27BF}]|[\u{1F900}-\u{1F9FF}]|[\u{1F018}-\u{1F270}]|[\u{238C}-\u{2454}]|[\u{20D0}-\u{20FF}]|[\u{FE00}-\u{FE0F}]|[\u{1F004}]|[\u{1F0CF}]|[\u{1F170}-\u{1F251}]/gu,
};
